import { useMemo, useState } from "react";
import { GameButton } from "../components/GameButton";
import { NumgnumCard } from "../components/NumgnumCard";
import type { Edition } from "../lib/cards";

export function ForgePage() {
  const [level, setLevel] = useState(1);
  const [edition, setEdition] = useState<Edition>("arcade");
  const [forged, setForged] = useState(false);
  const safeEdition: Edition = edition === "midnight" ? "midnight" : "arcade";
  const outcome = useMemo(() => Math.min(level + 1, 9), [level]);
  const isWorldFirst = outcome > 5;

  const cycle = () => {
    setForged(false);
    setLevel((value) => value >= 5 ? 1 : value + 1);
    setEdition((value) => value === "midnight" ? "arcade" : "midnight");
  };

  return (
    <div className="forge-page page-scene">
      <div className="forge-smoke" aria-hidden="true" />
      <img src="/art/brand/grinning-forge-emblem.webp" className="forge-logo" alt="Grinning forge" />
      <div className="scene-heading">
        <p className="eyebrow">Let the bad idea cook</p>
        <h1>Make worse ones.</h1>
        <p>Match two cards with the same NUMGNUM value and edition. The new card keeps that edition. The forge chooses whether your judgment was sound.</p>
      </div>
      <div className={`forge-demo ${forged ? "has-forged" : ""}`}>
        <button type="button" className="forge-slot" onClick={cycle} aria-label="Change forge cards">
          <NumgnumCard level={level} edition={safeEdition} interactive={false} />
        </button>
        <div className="forge-plus">+</div>
        <button type="button" className="forge-slot" onClick={cycle} aria-label="Change forge cards">
          <NumgnumCard level={level} edition={safeEdition} interactive={false} />
        </button>
        <div className="forge-equals">→</div>
        <div className="forge-outcome">
          {!forged && (
            <button type="button" className="forge-outcome-trigger" onClick={() => setForged(true)} aria-label="Ignite the bad idea">
              <span className="forge-ghost-card" aria-hidden="true"><img src="/art/brand/grinning-forge-emblem.webp" alt="" /><strong>?</strong><span>OUTCOME UNKNOWN</span></span>
            </button>
          )}
          {forged && !isWorldFirst && <NumgnumCard level={outcome} edition={safeEdition} interactive={false} />}
          {forged && isWorldFirst && <div className="forge-ghost-card forge-ghost-card--founded"><img src="/art/brand/grinning-forge-emblem.webp" alt="" /><strong>!</strong><span>A NEW NUMGNUM</span><small>The first card stays secret until somebody truly forges it.</small></div>}
        </div>
      </div>
      <div className="forge-actions">
        <GameButton onClick={() => setForged(true)}>Ignite the bad idea</GameButton>
        <GameButton onClick={cycle} tone="sea">Change ingredients</GameButton>
      </div>
      <aside className="forge-receipt" aria-label="Founder card permanent receipt">
        <span>First mistake · Permanent receipt</span>
        <p>Be first to wake a new edition and Serial No. 1 crawls out with your name fused to the permanent receipt. Hoard it. Flex it. Send it to the Exchange. The card can change hands; the first mistake stays yours forever.</p>
        <strong>Origin credit: fused forever</strong>
      </aside>
    </div>
  );
}
